var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab3-box"},[_c('videoItem',{attrs:{"user":_vm.tab3User,"tab3CurrentShare":_vm.tab3CurrentShare,"idPix":"tab3-video"},on:{"dobClick":_vm.dobuleTab3Click}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }